<script lang="ts">
import { defineComponent } from 'vue';
import { formatCurrency, formatMoney } from '@/utils/format';

export default defineComponent({
  name: 'row-possible-multiple-outcome',
  computed: {
    odds() {
      return this.stake.bets.map((bet: { odds: string }) => bet.odds);
    },
    stakeRow() {
      return this.stake.bets.map((bet: { odds: number }) => bet.odds);
    },
  },
  methods: { formatMoney, formatCurrency },
  props: ['stake'],
});
</script>

<template>
  <hr style="border-color: #ffffff20"/>
  <hr style="border-color: #ffffff20"/>
  <hr style="border-color: #ffffff20"/>

  <span>Возможный выигрыш</span>
  <span class="col-span-2">
    <span class="flex gap-1 text-center justify-start vertical-mid flex-wrap items-center">
      <template v-for="k in stakeRow">
        <span class="bg-gray-300 dark:bg-gray-700 px-2 rounded">
          {{ k }}
        </span>
        <span class="px-2">&#x00D7;</span>
      </template>
      <span class="bg-green-300 dark:bg-green-700 px-2 rounded">
        <b>{{ formatMoney(+stake.stakeAmount) }}</b>
        {{ formatCurrency(+stake.stakeAmount, stake.currency) }}
      </span>
      <span class="text-gray-500 text-lg mx-2"> = </span>
      <span class="text-lg">
        {{ formatMoney(+stake.maxPayout) }}
        {{ formatCurrency(+stake.maxPayout, stake.currency) }}
      </span>
      <span class="text-gray-500 text-lg mx-2">
        {{ formatMoney(+stake.vendorMaxPayout) }}
        {{ formatCurrency(+stake.vendorMaxPayout, stake.vendorCurrency) }}
      </span>
    </span>
  </span>
</template>

<style scoped lang="scss"></style>
